import { useEffect } from 'react';

/** Moves the hero court and its glow at different rates as the page scrolls. */
export function useParallax(): void {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 720) return;

    const layers: Array<{ el: HTMLElement; rate: number }> = [
      { sel: '.court-plane', rate: 0.16 },
      { sel: '.hero-glow', rate: 0.1 },
      { sel: '.rally', rate: 0.08 },
    ]
      .map(({ sel, rate }) => {
        const el = document.querySelector<HTMLElement>(sel);
        return el ? { el, rate } : null;
      })
      .filter((l): l is { el: HTMLElement; rate: number } => l !== null);

    if (!layers.length) return;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y < window.innerHeight * 1.6) {
          layers.forEach(({ el, rate }) => {
            el.style.translate = `0 ${(y * rate).toFixed(1)}px`;
          });
        }
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
}
